"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 181609845504;
const slug = exports.slug = 'reference/ui-components/design-patterns/buttons';
// translate-ignore
const navTitle = exports.navTitle = 'Buttons';
const title = exports.title = 'Button design patterns';
const name = exports.name = 'Button design patterns';
const metaDescription = exports.metaDescription = 'Learn about the design patterns HubSpot recommends for using buttons in app cards.';
const toc = exports.toc = [{
  "depth": 0,
  "id": "patterns",
  "label": "Patterns",
  "parent": null
}, {
  "depth": 0,
  "id": "examples",
  "label": "Examples",
  "parent": null
}, {
  "depth": 1,
  "id": "buttons-in-modals",
  "label": "Buttons in modals",
  "parent": "examples"
}, {
  "depth": 1,
  "id": "buttons-in-panels",
  "label": "Buttons in panels",
  "parent": "examples"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      code: "code",
      a: "a",
      h2: "h2",
      h3: "h3"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      CardsRow,
      Card,
      IFrame
    } = _components;
  if (!Card) _missingMdxReference("Card", true);
  if (!CardsRow) _missingMdxReference("CardsRow", true);
  if (!IFrame) _missingMdxReference("IFrame", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Buttons"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Include ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "Button"
      }), " components to enable users to perform actions in app cards, such as submitting a form, sending data to an external system, or deleting data."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Follow the design patterns below to keep your app card consistent with HubSpot's designs. To learn more about implementation, check out the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/ui-components/standard-components/button",
        children: "Button component reference documentation"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Patterns"
    }), "\n", (0, _jsxRuntime.jsxs)(CardsRow, {
      children: [(0, _jsxRuntime.jsxs)(Card, {
        children: [(0, _jsxRuntime.jsx)("h3", {
          children: "Variants"
        }), (0, _jsxRuntime.jsxs)("ul", {
          children: [(0, _jsxRuntime.jsx)("li", {
            children: (0, _jsxRuntime.jsxs)(_components.p, {
              children: ["Only include one ", (0, _jsxRuntime.jsx)(_components.code, {
                children: "primary"
              }), " button per surface (e.g., one per panel, one\nper modal). The button should be reserved for the main action that a\nuser can perform."]
            })
          }), (0, _jsxRuntime.jsx)("li", {
            children: (0, _jsxRuntime.jsxs)(_components.p, {
              children: ["To avoid confusion, don’t pair ", (0, _jsxRuntime.jsx)(_components.code, {
                children: "destructive"
              }), " variant buttons with\n", (0, _jsxRuntime.jsx)(_components.code, {
                children: "primary"
              }), " buttons. Limit button pairings to either ", (0, _jsxRuntime.jsx)(_components.code, {
                children: "primary"
              }), " and\n", (0, _jsxRuntime.jsx)(_components.code, {
                children: "secondary"
              }), " or ", (0, _jsxRuntime.jsx)(_components.code, {
                children: "destructive"
              }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
                children: "secondary"
              }), "."]
            })
          }), (0, _jsxRuntime.jsx)("li", {
            children: (0, _jsxRuntime.jsx)(_components.p, {
              children: "In general, use the default button size. You should only be sizing down\nif it’s necessary for the space that the button is being placed in\n(e.g., in a table with narrow rows)."
            })
          })]
        })]
      }), (0, _jsxRuntime.jsxs)(Card, {
        children: [(0, _jsxRuntime.jsx)("h3", {
          children: "Alignment"
        }), (0, _jsxRuntime.jsxs)("ul", {
          children: [(0, _jsxRuntime.jsx)("li", {
            children: (0, _jsxRuntime.jsxs)(_components.p, {
              children: ["Always position buttons at the bottom of\n", (0, _jsxRuntime.jsx)(_components.a, {
                href: "/reference/ui-components/standard-components/form",
                children: "Form"
              }), ",\n", (0, _jsxRuntime.jsx)(_components.a, {
                href: "/reference/ui-components/standard-components/modal",
                children: "Modal"
              }), " and\n", (0, _jsxRuntime.jsx)(_components.a, {
                href: "/reference/ui-components/standard-components/panel",
                children: "Panel"
              }), " components."]
            })
          }), (0, _jsxRuntime.jsx)("li", {
            children: (0, _jsxRuntime.jsxs)(_components.p, {
              children: ["Buttons should always be aligned to the left. When pairing ", (0, _jsxRuntime.jsx)(_components.code, {
                children: "primary"
              }), " and\n", (0, _jsxRuntime.jsx)(_components.code, {
                children: "secondary"
              }), " variant buttons, the ", (0, _jsxRuntime.jsx)(_components.code, {
                children: "primary"
              }), " button should appear as the\nleftmost button. The only time you should align a button to the right of\na container is for buttons that navigate through multi-step forms, as\nthis is where the user will intuitively click."]
            })
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Examples"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The examples below are taken from HubSpot's ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/ui-extensions-examples/tree/main/design-patterns",
        children: "design patterns example app"
      }), " and ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/reference/ui-components/design/figma-design-kit",
        children: "Figma design kit"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Buttons in modals"
    }), "\n", (0, _jsxRuntime.jsx)(IFrame, {
      width: "645",
      height: "450",
      src: "https://embed.figma.com/design/jJ1Wq7Q3O0iLnbSZTyYjS6/HubSpot-Extensibility-Design-Kit?node-id=1422-2054&embed-host=share&footer=false&page-selector=false",
      allowfullscreen: true
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/ui-extensions-examples/blob/main/design-patterns/src/app/extensions/components/ModalExample.tsx",
        children: "View code on GitHub"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Buttons in panels"
    }), "\n", (0, _jsxRuntime.jsx)(IFrame, {
      width: "645",
      height: "450",
      src: "https://embed.figma.com/design/jJ1Wq7Q3O0iLnbSZTyYjS6/HubSpot-Extensibility-Design-Kit?node-id=635-445&embed-host=share&footer=false&page-selector=false",
      allowfullscreen: true
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://github.com/HubSpot/ui-extensions-examples/blob/main/design-patterns/src/app/extensions/components/PanelExample.tsx",
        children: "View code on GitHub"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}